import { ContainerModule } from '@evertel/di'
import { SendInvitesController, DepartmentInviteLinkController, ConsumeInviteController, DepartmentSeatStatusController } from './controller'

const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(SendInvitesController).toSelf()
        m.bind(DepartmentInviteLinkController).toSelf()
        m.bind(ConsumeInviteController).toSelf()
        m.bind(DepartmentSeatStatusController).toSelf()
    })
]

export { DI_MODULES }
